import { SxProps, Theme } from '@mui/material';

export const searchElementSx: SxProps<Theme> = ({ shape }) => ({
  bgcolor: 'grey.50',
  borderRadius: Number(shape.borderRadius) * 2,
  p: 2,
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  fontSize: '18px',
  color: 'text.secondary',
  '& input::placeholder': {
    fontSize: '18px',
    color: 'text.secondary',
    opacity: 1,
  },
});
